import { Preferences } from "./profile";
import type { ProfileCommon } from "./profileCommon";
import type { Role } from "./roles";

export type AdminUserType = "ADMIN" | "CSM" | "CSE";

export type AdminProfile = ProfileCommon & {
  /** SSO identity provider identifier */
  idp?: string;
  idp_logout_url?: string;
  preferences?: Preferences;
  role: Role;
  /** Distinguishes admin sub-roles, e.g. "CSE", "CSM", "ADMIN" */
  user_type: AdminUserType | string;
};

/** Narrows a profile value to AdminProfile at runtime */
export function isAdminProfile(profile: unknown): profile is AdminProfile {
  return typeof profile === "object" && profile !== null && "user_type" in profile;
}
